import { prefixObjectValues } from '../utils';

const welcome = {
  title: 'title',
  mfa: 'mfa-toggle',
  phone: 'phone-input',
  tosToggle: 'tos-toggle',
  tosModalOpen: 'tos-modal-open',
  tosModalClose: 'tos-modal-open',
  loadingBar: 'loading-bar',
  nextButton: 'next-button',
  backButton: 'back-button',
  mfaError: 'mfa-error',
  tosError: 'tos-error',
};

export default prefixObjectValues(welcome, 'registration-welcome');
